export default __webpack_public_path__ + "static/media/logo-malikaLeroy-clear.ced93ce9.svg";